'use client'

import { SelectInput, useConfig, useField } from '@payloadcms/ui';
import { TextFieldClientProps } from 'payload';
import * as React from 'react';
import { RobotTool } from '../../api/types';

type SelectOption = {
  label: string;
  value: string;
};

export const LlmTool: React.FC<TextFieldClientProps> = ({ path }) => {
  const { value, setValue } = useField<string>({ path });
  const [options, setOptions] = React.useState<SelectOption[]>([]);
  const { config } = useConfig();
  const { routes: { api: apiRoute } = {} } = config;

  React.useEffect(() => {
    const fetchOptions = async () => {
      try {
        const response = await fetch(`${apiRoute}/llm/tools`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          referrer: '',
        });
        if (response.ok) {
          const tools = (await response.json()) as RobotTool[];
          const options: SelectOption[] = tools
            .map((tool) => ({
              label: tool.id,
              value: tool.value,
            }))
            .sort((a, b) => a.label.localeCompare(b.label));
          setOptions(options);
        } else {
          setOptions([{ label: (await response.json()).message, value: '' }]);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchOptions();
  }, []);

  return (
    <div className="field-type select">
      <label
        className="field-label"
        htmlFor={`field-${path}`.replace(/\./g, '__')}
      >
        LLM functionName
      </label>
      <SelectInput
        path={path}
        name={path}
        options={options}
        value={value}
        onChange={(option) => Array.isArray(option) ? null : setValue(option.value)}
      />
    </div>
  );
};
